import { useState } from 'react';

import { formatNumber, formatDate, formatBigNumber, formatDecimal } from 'Util';

const OutlineEtf = ({ data }) => {

  const [isActive, setIsActive] = useState(false);

  function renderComp(val) {
    if (val) {
      return val + '개'
    }
    return '-';
  }

	return (
    <div className={"summary" + (isActive ? ' is-active' : '')}>
      <div className="title">{data.TICKER_NAME} 개요</div>
      <div className="text">{data.outline.SUMMARY}</div>
      <div 
        className="toggle"
        onClick={(e) => {
          e.preventDefault();
          setIsActive(!isActive);
        }}
      >
        <span>{isActive ? '펼치기' : '접기'}</span><i></i>
      </div>
      <div className="info">
          <div className="tit">{data.TICKER_NAME}</div>
          <div className="con">
              <dl className="bold txt_basic">
                  <dt>전일종가</dt>
                  { data.CTR_TYP === 1 &&
                  <dd>{formatNumber(data.outline.PRICE)}원</dd>
                  }
                  { data.CTR_TYP === 2 &&
                  <dd>${formatDecimal(data.outline.PRICE, 2)}</dd>
                  }
              </dl>
              <dl className="bold txt_basic">
                  <dt>시가총액</dt>
                  { data.CTR_TYP === 1 &&
                  <dd>{formatBigNumber(data.outline.MKT_VAL)}원</dd>
                  }
                  { data.CTR_TYP === 2 &&
                  <dd>${formatBigNumber(data.outline.MKT_VAL)}</dd>
                  }
              </dl>
              <dl>
                  <dt>기초지수</dt>
                  <dd>{data.outline.BASE_INDEX}</dd>
              </dl>
              <dl>
                  <dt>기초자산</dt>
                  <dd>{data.outline.BASE_ASSET}</dd>
              </dl>
              <dl>
                  <dt>운용사</dt>
                  <dd>{data.outline.CIM}</dd>
              </dl>
              <dl>
                  <dt>상장일</dt>
                  <dd>{formatDate(data.outline.LIST_DT)}</dd>
              </dl>
              <dl>
                  <dt>상품종류</dt>
                  <dd>{data.outline.COMMODITY_TYP}</dd>
              </dl>
              <dl>
                  <dt>상품유형</dt>
                  <dd>{data.outline.COMMODITY_CATEGORY}</dd>
              </dl>
              <dl>
                  <dt>과세유형</dt>
                  <dd>{data.outline.TAX_TYP}</dd>
              </dl>
              <dl>
                  <dt>구성종목</dt>
                  <dd>{renderComp(data.outline.COMP)}</dd>
              </dl>
              <dl>
                  <dt>총보수</dt>
                  <dd>{formatDecimal(data.outline.FEE, 2)}{data.outline.FEE && '%'}</dd>
              </dl>
              <dl>
                  <dt>52주 고가/저가</dt>
                  { data.CTR_TYP === 1 &&
                  <dd>{formatNumber(data.outline.MIN_52W_PRC)}원 / {formatNumber(data.outline.MAX_52W_PRC)}원</dd>
                  }
                  { data.CTR_TYP === 2 &&
                  <dd>${formatDecimal(data.outline.MIN_52W_PRC, 2)} / ${formatDecimal(data.outline.MAX_52W_PRC, 2)}</dd>
                  }
              </dl>
              <dl>
                  <dt>20일 평균거래액</dt>
                  { data.CTR_TYP === 1 &&
                  <dd>{formatBigNumber(data.outline.TRD_AMT_20D)}원</dd>
                  }
                  { data.CTR_TYP === 2 &&
                  <dd>${formatBigNumber(data.outline.TRD_AMT_20D)}</dd>
                  }
              </dl>
              <dl>
                  <dt>3년 평균 분배금</dt>
                  { data.CTR_TYP === 1 &&
                  <dd>{data.outline.DIV_3Y ? data.outline.DIV_3Y + '원' : '-'}</dd>
                  }
                  { data.CTR_TYP === 2 &&
                  <dd>{data.outline.DIV_3Y ? '$' + data.outline.DIV_3Y : '-'}</dd>
                  }
              </dl>
          </div>
      </div>
    </div>
  );
}

export default OutlineEtf;
